var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNote2Svg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M9.99983 6.66667V10M9.99983 13.3333H10.0082M8.57483 2.38334L1.5165 14.1667C1.37097 14.4187 1.29397 14.7044 1.29316 14.9954C1.29234 15.2865 1.36774 15.5726 1.51186 15.8254C1.65597 16.0783 1.86377 16.289 2.11459 16.4366C2.36541 16.5841 2.6505 16.6635 2.9415 16.6667H17.0582C17.3492 16.6635 17.6343 16.5841 17.8851 16.4366C18.1359 16.289 18.3437 16.0783 18.4878 15.8254C18.6319 15.5726 18.7073 15.2865 18.7065 14.9954C18.7057 14.7044 18.6287 14.4187 18.4832 14.1667L11.4248 2.38334C11.2763 2.13843 11.0671 1.93594 10.8175 1.79541C10.5679 1.65488 10.2863 1.58105 9.99983 1.58105C9.71339 1.58105 9.43178 1.65488 9.18217 1.79541C8.93257 1.93594 8.72339 2.13843 8.57483 2.38334Z",
    stroke: "#FFC107",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote2Svg);
export default __webpack_public_path__ + "static/media/Note2Svg.10c7f6bba879e1aaf823f5910b33882d.svg";
export { ForwardRef as ReactComponent };